import {
	NewsSyncRequest,
	NewsSyncOnlyRequest,
	NewsTranslateRequest,
	NewsSyncResponse,
	JobRef,
	ProgressItem,
	PremiumSyncRequest
} from '../dto/sync';
import type { PremiumSyncStatusResponse } from '../dto/categories';
import { httpArg, httpPost, httpRoute, httpUserId, optionalHttpUserId } from '../infrastructure/http/http-decorators';

/**
 * Service for triggering news sync and tracking progress.
 */
@httpRoute('/api/sync')
export abstract class ISyncApiService {
	/**
	 * Trigger news sync and translation jobs
	 * @deprecated Use syncNews and translateNews separately
	 */
	@httpPost('sync-news-and-translate')
	syncNewsAndTranslate(
			@httpArg('request') request: NewsSyncRequest,
			@httpUserId() userId?: string
	): Promise<NewsSyncResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Trigger news sync only (without translation)
	 */
	@httpPost('sync-news')
	syncNews(
			@httpArg('request') request: NewsSyncOnlyRequest,
			@optionalHttpUserId() userId?: string
	): Promise<NewsSyncResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Trigger news translation only
	 */
	@httpPost('translate-news')
	translateNews(
			@httpArg('request') request: NewsTranslateRequest,
			@optionalHttpUserId() userId?: string
	): Promise<NewsSyncResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Get current status of sync jobs
	 */
	@httpPost('get-sync-status')
	getSyncStatus(
			@httpArg('jobs') jobs: JobRef[],
			@optionalHttpUserId() userId?: string): Promise<ProgressItem[]> {
		void jobs;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Premium: trigger custom user categories sync (requires active premium)
	 */
	@httpPost('sync-premium-user-categories')
	syncPremiumUserCategories(
			@httpArg('request') request: PremiumSyncRequest,
			@httpUserId() userId?: string
	): Promise<{ readonly status: 'accepted' }> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Premium: trigger news translations sync (requires active premium)
	 */
	@httpPost('sync-premium-news-translations')
	syncPremiumNewsTranslations(
			@httpArg('request') request: PremiumSyncRequest,
			@httpUserId() userId?: string
	): Promise<{ readonly status: 'accepted' }> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	/**
	 * Premium: get premium sync status (requires active premium)
	 */
	@httpPost('get-premium-sync-status')
	getPremiumSyncStatus(
			@httpArg('request') request: PremiumSyncRequest,
			@httpUserId() userId?: string
	): Promise<PremiumSyncStatusResponse> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}
}
